import moment from "moment";
import getDateArrayBetweenDates from "./getDateArrayBetweenDates";

/**
 * @param {string} startDate - Fecha de inicio formato YYYY-MM-DD
 * @param {string} endDate - Fecha de fin formato YYYY-MM-DD
 * @returns {Array<{value: String, text: String}>} - Retorna labels para el gráfico diario de conversaciones
 */
export default function getFakeLabelsGraficoDiario(startDate, endDate) {
    const dates = getDateArrayBetweenDates(startDate, endDate);
    return dates.map((date) => ({
        value: date,
        text: moment(date, "YYYY-MM-DD").format("YY-MM-DD"),
    }));
}